import React from 'react';
import styles from './PageContainer.module.css';

const PageContainer = ({ children, className = '' }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {children}
    </div>
  );
};

export default PageContainer;
